import { t as ZepIcon } from "../ZepIcon-BjEF3k8i.mjs";
import { jsx } from "react/jsx-runtime";
//#region src/components/XBold.tsx
const XBoldIcon = ZepIcon((props) => /* @__PURE__ */ jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	...props,
	children: /* @__PURE__ */ jsx("path", {
		d: "M19.265 4.606c.68.68.68 1.784 0 2.464l-4.803 4.804 5.053 5.054a1.743 1.743 0 1 1-2.464 2.464l-5.054-5.054-5.054 5.054a1.743 1.743 0 0 1-2.464-2.464l5.054-5.054L4.729 7.07a1.743 1.743 0 1 1 2.465-2.464l4.803 4.804 4.804-4.804c.68-.68 1.784-.68 2.464 0Z",
		fill: props.fill || "currentColor"
	})
}));
//#endregion
export { XBoldIcon };
